export interface FurtherTreatmentComments{
    hasFurtherTreatmentComments: boolean,
    furtherTreatmentComments: string
}

export const defaultFurtherTreatmentComments: FurtherTreatmentComments = {
    hasFurtherTreatmentComments: false,
    furtherTreatmentComments: ""
}